import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import getRecommendedIssues from "../../components/IssueDetails/getRecommendedIssues";

const C = {
  mid: "#2d5a3d",
  bright: "#3d8c5e",
  light: "#e8f5ee",
  border: "#d8e8dc",
  cardBorder: "#c6deca",
  white: "#ffffff",
  textDk: "#1a2e22",
  textGr: "#5a6e61",
  orange: "#e65100",
  orangeBg: "#fff3e0",
  blue: "#1565c0",
  blueBg: "#e3f2fd",
  red: "#c62828",
  redBg: "#fdecea",
};

const issueStatusStyle = (status) => {
  const map = {
    New: { bg: C.blueBg, color: C.blue },
    "In Progress": { bg: C.orangeBg, color: C.orange },
    SolutionProvided: { bg: "#e8f5e9", color: "#2e7d32" },
    Done: { bg: C.light, color: C.mid },
    "On Hold": { bg: "#eceff1", color: "#607d8b" },
    "In Follow": { bg: "#f3e5f5", color: "#7b1fa2" },
    Rejected: { bg: C.redBg, color: C.red },
  };
  return map[status] || { bg: "#f5f5f5", color: "#555" };
};

const RecommendedIssues = (props) => {
  const [fetching, setFetching] = useState(true);
  const [recommended, setRecommended] = useState([]);

  const loadRecommendedIssues = async () => {
    setFetching(true);
    const recommendedResponse = await getRecommendedIssues(props.issueDetails);
    if (recommendedResponse.status == 200) {
      const issues = recommendedResponse.data.issues;
      setRecommended(issues);
      console.log(recommendedResponse);
      if (props.onCountLoaded) props.onCountLoaded(issues.length);
    } else {
      console.log(recommendedResponse);
      if (props.onCountLoaded) props.onCountLoaded(0);
    }
    setFetching(false);
  };

  useEffect(() => {
    loadRecommendedIssues();
  }, []);

  if (fetching) {
    return (
      <div style={{ padding: "1.25rem", textAlign: "center", fontSize: "0.85rem", color: C.textGr }}>
        Loading similar issues…
      </div>
    );
  }

  if (recommended.length === 0) {
    return (
      <div style={{ padding: "1.5rem", textAlign: "center" }}>
        <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: "1.5rem", color: C.cardBorder, marginBottom: "0.5rem", display: "block" }} />
        <div style={{ fontSize: "0.85rem", fontWeight: 600, color: C.textGr }}>No Similar Issues Found</div>
        <div style={{ fontSize: "0.75rem", color: "#aab8b0", marginTop: 3 }}>No issues match this crop or problem type</div>
      </div>
    );
  }

  return (
    <div style={{ padding: "0.75rem 1rem" }}>
      {recommended.map((val) => {
        const st = issueStatusStyle(val.status);
        return (
          <Link key={val.issueCode} to={`/viewIssue/${val.issueCode}`} style={{ textDecoration: "none" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.65rem",
                padding: "0.6rem 0.75rem",
                borderRadius: 8,
                marginBottom: 6,
                backgroundColor: "#f8faf8",
                border: `1px solid ${C.cardBorder}`,
                transition: "background 0.1s",
              }}
            >
              {/* Status icon dot */}
              <div
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: st.color,
                  flexShrink: 0,
                }}
              />

              {/* Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: "0.83rem",
                    fontWeight: 600,
                    color: C.textDk,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {val.title || "—"}
                </div>
                <div style={{ fontSize: "0.7rem", color: C.textGr }}>
                  #{val.issueCode}
                  {val.cropName ? ` · ${val.cropName}` : ""}
                </div>
              </div>

              {/* Status pill */}
              <span
                style={{
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  padding: "2px 9px",
                  borderRadius: 8,
                  backgroundColor: st.bg,
                  color: st.color,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                {val.status}
              </span>

              <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "0.6rem", color: C.textGr, flexShrink: 0 }} />
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default RecommendedIssues;
